import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Billable from "@material-ui/icons/Style";
import Token from "@material-ui/icons/AssignmentTurnedIn";
import TokenBalance from "@material-ui/icons/AccountBalanceWalletTwoTone";
import FlightIcon from "@material-ui/icons/Flight";
import UpdateIcon from "@material-ui/icons/Info";
import DateIcon from "@material-ui/icons/DateRange";
import { appHelpers } from "../../_helpers";

export const SummaryCard = ({
  passengerCount,
  startDate,
  endDate,
  classes,
  billablePax,
  totalBillableAmount,
  tokensPurchased,
  unUtilizedToken,
  totalFlights,
  openDateDialog,
}) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={6} md={4}>
        <Card className={"dashboard-card"}>
          <CardHeader color="regional" stats icon className={"dashboard-header"}>
            <CardIcon color="regional">
              <Passenger />
            </CardIcon>
            <p className={`${classes.cardCategory} dashboard-category`}>
              Billable Passengers
            </p>
            <h3 className={`${classes.cardTitle} dashboard-title`}>
              {appHelpers.numberWithCommasOnly(billablePax)}
            </h3>
            <span className="paragraph-end">&nbsp;</span>
          </CardHeader>
          <CardFooter stats className={"card-footer"}>
            <div className={classes.stats}>
              <UpdateIcon />
              out of {appHelpers.numberWithCommasOnly(passengerCount)}
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={4}>
        <Card className={"dashboard-card"}>
          <CardHeader color="info" stats icon className={"dashboard-header"}>
            <CardIcon color="info">
              <Billable />
            </CardIcon>
            <p className={`${classes.cardCategory} dashboard-category`}>
              Total Billable Amount
            </p>
            <h3 className={`${classes.cardTitle} dashboard-title`}>
              $ {appHelpers.numberWithCommas(totalBillableAmount)}
            </h3>
            <span className="paragraph-end">&nbsp;</span>
          </CardHeader>
          <CardFooter stats className={"card-footer"}>
            <div className={classes.stats}>
              {/*<UpdateIcon />*/}
              {/*Last 24 Hours*/}
              &nbsp; &nbsp;
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={4}>
        <Card className={"dashboard-card"}>
          <CardHeader color="danger" stats icon className={"dashboard-header"}>
            <CardIcon color="danger">
              <Token />
            </CardIcon>
            <p className={`${classes.cardCategory} dashboard-category`}>
              Total Amount Purchased
            </p>
            <h3 className={`${classes.cardTitle} dashboard-title`}>
              {appHelpers.numberWithCommasOnly(tokensPurchased)}
            </h3>
            <span className="paragraph-end">&nbsp;</span>
          </CardHeader>
          <CardFooter stats className={"card-footer"}>
            <div className={classes.stats}>
              {/*<UpdateIcon />*/}
              {/*Last 24 Hours*/}
              &nbsp; &nbsp;
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={4}>
        <Card className={"dashboard-card"}>
          <CardHeader color="regional" stats icon className={"dashboard-header"}>
            <CardIcon color="regional">
              <TokenBalance />
            </CardIcon>
            <p className={`${classes.cardCategory} dashboard-category`}>
              Unutilized Amount
            </p>
            <h3 className={`${classes.cardTitle} dashboard-title`}>
              {appHelpers.numberWithCommasOnly(unUtilizedToken)}
            </h3>
            <span className="paragraph-end">&nbsp;</span>
          </CardHeader>
          <CardFooter stats className={"card-footer"}>
            <div className={classes.stats}>
              {/*<UpdateIcon />*/}
              {/*Last 24 Hours*/}
              &nbsp; &nbsp;
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={4}>
        <Card className={"dashboard-card"}>
          <CardHeader color="info" stats icon className={"dashboard-header"}>
            <CardIcon color="info">
              <FlightIcon />
            </CardIcon>
            <p className={`${classes.cardCategory} dashboard-category`}>
              Total Flights
            </p>
            <h3 className={`${classes.cardTitle} dashboard-title`}>
              {appHelpers.numberWithCommasOnly(totalFlights)}
            </h3>
            <span className="paragraph-end">&nbsp;</span>
            <span className="paragraph-end">&nbsp;</span>
          </CardHeader>
          <CardFooter stats className={"card-footer"}>
            <div className={classes.stats}>
              {/*<UpdateIcon />*/}
              {/*Last 24 Hours*/}
              &nbsp; &nbsp;
            </div>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={4}>
        <Card className={"dashboard-card"}>
          <CardHeader color="danger" stats icon className={"dashboard-header"}>
            <CardIcon color="danger">
              <DateIcon />
            </CardIcon>
            <p className={`${classes.cardCategory} dashboard-category`}>
              Date Range
            </p>
            <h4 className={`${classes.cardTitle} dashboard-title`}>
              {appHelpers.formatDateSpecific(startDate, "MMM DD, 'YY")}
              &nbsp; - &nbsp;
              {appHelpers.formatDateSpecific(endDate, "MMM DD, 'YY")}
            </h4>
            <span className="paragraph-end">&nbsp;</span>
            <span className="paragraph-end">&nbsp;</span>
          </CardHeader>
          <CardFooter stats className={"card-footer"}>
            <div className={classes.stats}>
              <DateIcon />
              <a href="" onClick={openDateDialog}>
                <strong>Change Date</strong>
              </a>
            </div>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
  );
};



// WEBPACK FOOTER //
// ./src/Regional-Views/Dashboard/SummaryCard.js